import { Map, Leaf, SlidersHorizontal, ShieldCheck, MessageCircle } from "lucide-react";
import { WHY_US } from "../data/content";
import { FadeUp, SectionHead } from "./Reveal";

const ICONS = {
  map: Map,
  leaf: Leaf,
  sliders: SlidersHorizontal,
  shield: ShieldCheck,
  message: MessageCircle,
};

export const WhyUs = () => (
  <section id="why" data-testid="why-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-14">
        <SectionHead
          num="07"
          eyebrow="Why HiddenBiomes"
          title="Planned Like It Matters. Because It Does."
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {WHY_US.map((w, i) => {
          const Icon = ICONS[w.icon];
          return (
            <FadeUp key={w.title} delay={i * 0.08}>
              <div
                data-testid={`why-card-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group h-full p-7 border border-gold/10 hover:border-gold/40 bg-forest-900/40 hover:bg-forest-900/80 hover:-translate-y-2 transition-all duration-500"
              >
                <span className="font-mono text-[10px] text-gold/50 tracking-[0.25em]">
                  0{i + 1}
                </span>
                <Icon size={22} className="text-gold mt-5 mb-5" strokeWidth={1.5} />
                <h3 className="font-serif text-xl text-cream leading-snug">{w.title}</h3>
                <p className="text-sm text-fog group-hover:text-sage mt-3 leading-relaxed transition-colors duration-500">
                  {w.desc}
                </p>
              </div>
            </FadeUp>
          );
        })}
      </div>
    </div>
  </section>
);
